import {Controller} from "@hotwired/stimulus"
import Inputmask from "inputmask"

export default class extends Controller<HTMLInputElement> {
  connect() {
    console.log('connected phone');

    const im = new Inputmask({
      mask: "+7 (999) 999-99-99",
      onBeforeMask: (value) => {
        if (value.length == 11) {
          return value.replace(/^7/, '')
        } else {
          return value;
        }
      }
    })
    im.mask(this.element)
  }
}
